import React from 'react'

import Section from '../../../../../../components/Section'
import PurchaseLotTable from './PurchaseTab/Table/PurchaseLotTable'
import { CurrencyList } from '../../../types'

type Props = {
    purchaseGuid: string
    purchaseRegNumber: string
    purchaseAction: boolean
    theme: string
    isActive: boolean
    currencyList: CurrencyList[]
}

const PurchaseLotTab: React.FC<Props> = (props) => {
    return (
        <Section title="Информация о лотах">
            <div className="flex flex-col w-full gap-x-5 ">
                <PurchaseLotTable
                    theme={props.theme}
                    purchaseGuid={props.purchaseGuid}
                    purchaseRegNumber={props.purchaseRegNumber}
                    purchaseAction={props.purchaseAction}
                    isActive={props.isActive}
                    currencyList={props.currencyList}
                />
            </div>
        </Section>
    )
}

export default PurchaseLotTab
